export interface ToggleOption<T extends string | number> {
  value: T;
  label: string;
}

interface ToggleButtonGroupProps<T extends string | number> {
  value: T;
  options: ToggleOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
  /** Cuando es true, los botones reparten el ancho completo del contenedor en partes iguales. */
  fullWidth?: boolean;
}

function ToggleButtonGroup<T extends string | number>({
  value,
  options,
  onChange,
  disabled = false,
  className = '',
  fullWidth = false,
}: ToggleButtonGroupProps<T>) {
  return (
    <div
      className={`
        ${fullWidth ? 'flex w-full' : 'inline-flex'}
        rounded-xl
        border
        border-stroke
        bg-gray-2
        p-1
        dark:border-strokedark
        dark:bg-meta-4
        ${disabled ? 'opacity-60' : ''}
        ${className}
      `}
    >
      {options.map((option) => {
        const active = option.value === value;

        return (
          <button
            key={String(option.value)}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={`
              ${fullWidth ? 'flex-1' : 'min-w-[88px]'}
              rounded-lg
              border
              px-4
              py-2
              text-sm
              font-medium
              transition-all
              duration-200

              ${
                active
                  ? `
                      border-stroke
                      bg-white
                      text-primary
                      shadow-sm
                      dark:border-transparent
                      dark:bg-boxdark
                    `
                  : `
                      border-transparent
                      bg-white/50
                      text-body
                      hover:bg-white
                      hover:text-black
                      hover:shadow-sm
                      dark:bg-transparent
                      dark:text-bodydark2
                      dark:hover:border-transparent
                      dark:hover:bg-boxdark
                      dark:hover:text-white
                    `
              }

              ${
                disabled
                  ? 'cursor-not-allowed opacity-50'
                  : 'cursor-pointer'
              }
            `}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default ToggleButtonGroup;